import * as Types from '../../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ExportCsvQueryVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
}>;


export type ExportCsvQuery = { __typename?: 'QueryRoot', exportCsv: { __typename?: 'ExportCsvPayload', exportValue?: { __typename?: 'ExportCsv', courseId: string, csvText: string } | null } };


export const ExportCsvDocument = gql`
    query ExportCsv($courseId: String!) {
  exportCsv(courseId: $courseId) {
    exportValue {
      courseId
      csvText
    }
  }
}
    `;

export function useExportCsvQuery(options: Omit<Urql.UseQueryArgs<ExportCsvQueryVariables>, 'query'>) {
  return Urql.useQuery<ExportCsvQuery, ExportCsvQueryVariables>({ query: ExportCsvDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExportCsvQuery((req, res, ctx) => {
 *   const { courseId } = req.variables;
 *   return res(
 *     ctx.data({ exportCsv })
 *   )
 * })
 */
export const mockExportCsvQuery = (resolver: ResponseResolver<GraphQLRequest<ExportCsvQueryVariables>, GraphQLContext<ExportCsvQuery>, any>) =>
  graphql.query<ExportCsvQuery, ExportCsvQueryVariables>(
    'ExportCsv',
    resolver
  )
